// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardDesignerHeaderAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry, isEmpty } from 'lodash/fp';
export default withHandlers({
  updateGlobalDashboardCheckbox: curry(updateGlobalDashboardCheckbox)
});

/**
 * Update global dashboard checkbox
 * @param {*} props
 * @param {*} e
 */
function updateGlobalDashboardCheckbox(props: any, e: any) {
  const value = e.target.checked;
  // validate access list and warning if change to global report
  const { store } = props;
  if (isEmpty(store.accessStore)) {
    store.initAccess();
  }
  const accessStore = store.accessStore;

  const result = accessStore.validateAccessListOnUpdateGlobalReport(value);

  if (result) {
    props.confirmFn('warning', { description: result }).then(() => {
      // call update global type update
      store.changeGlobalType(value);

      // update list access
      accessStore.updateListAccessor(value);
    });
  } else {
    store.changeGlobalType(value);
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/Izenda.DashboardDesignerHeaderAction.js